export const API = "https://gregorovius-edition.dhi-roma.it/api";

export const MATOMO_CONFIG = {
  enableMatomo: true,
  host: "https://dhiroma.matomo.cloud",
  siteId: 2
};
